<app-megamenu></app-megamenu>

<div class="page-content">
  <div class="container">
    <h1>About Complete Pest</h1>
    <p>Learn more about our company, our mission, and our commitment to providing saffe, reliable pest control services across Northern Utah.</p>
    
    <div class="content-section">
      <h2>Our Story</h2>
      <p>Complete Pest Control is a locally operated company dedicated to protecting homes and businesses across Northern Utah from unwanted pests.</p>
      <p>We believe pest control should be safe, effective, and dependable. Our team focuses on providing high-quality service using environmentally responsible treatment methods designed to eliminate pests while keeping your family, pets, and property safe.</p>
      <p>From ants and spiders to rodents and seasonal pests, we work hard to deliver reliable solutions and long-term pest prevention for the communities we serve.</p>
    </div>

    <div class="content-section">
      <h2>Our Mission</h2>
      <p>Our mission is to provide dependable pest control solutions that protect homes and businesses while maintaining the highest standards of safety, professionalism, and customer care.</p>
      <p>We are committed to using modern tools and efficient processes to streamline our operations so we can deliver high-quality pest control services at fair and competitive prices for our customers.</p>
    </div>
  </div>
</div>

<app-footer></app-footer>